'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isInvalid(dest) {
  return !dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum'];
} /*
   * A sanity check to see if the server has returned
   * a valid payload.
   *
   * If not, alert the developer so long as we're
   * not in production.
   */


var alertMsg = 'Server-side React render was discarded. ' + 'Make sure that your initial render does not ' + 'contain any client-side code.';

exports.default = function (dest) {
  if (_config.NODE_ENV === 'development') {
    window.React = _react2.default; // enable debugger

    if (isInvalid(dest)) {
      if (!_config.DISABLE_SERVER_RENDERING) {
        console.error(alertMsg);
      } else {
        console.log('Server side rendering is off');
      }
    }
  } else if (_config.DISABLE_SERVER_RENDERING) {
    console.log('Server side rendering is turned off on production');
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/browser/checkIfValidPayload.js
// module id = 1064
// module chunks = 0